import Logging from '../../Logging';
import PageData from '../../PageData';
import {PageViewType} from '../../types/PageViewType';
import {EventBus} from "../../events/EventBus";
import {ModalOpenedEvent} from "../../events/Events";

export default class Modal {
  private readonly element: HTMLElement;

  private readonly openTrigger: HTMLElement[] | undefined;

  private readonly closeTrigger: HTMLElement[];

  public onOpen: ((id: string | undefined, element?: HTMLElement) => void) | undefined;

  public onClose: (() => void) | undefined;

  private readonly contactFormModal = document.getElementById('contact-modal-form');

  private readonly pageData : PageData;

  private readonly eventBus: EventBus = EventBus.getInstance();

  constructor(params: {
    pageData: PageData
    element: HTMLElement,
    openTrigger?: HTMLElement[] | HTMLElement,
    closeTrigger: HTMLElement[] | HTMLElement,
    onOpen?: (id: string | undefined) => void,
    onClose?: () => void,
    isNestoriaMobile?: boolean
  }) {
    this.pageData = params.pageData;
    this.element = params.element;
    this.openTrigger = this.buildModalOpenTrigger(params.openTrigger);
    this.closeTrigger = Array.isArray(params.closeTrigger) ? params.closeTrigger : [params.closeTrigger];
    this.onOpen = params.onOpen;
    this.onClose = params.onClose;
    if (params.isNestoriaMobile) return;
    this.setupEventListeners();
  }

  private setupEventListeners = () => {
    if (!this.element) return Logging.warn('A Modal that was expected to be present was not found');

    try {
      if (this.openTrigger) {
        this.openTrigger.forEach(((value) => {
          if (value) value.addEventListener('click', this.open(value.id, value));
        }));
      }
      this.closeTrigger.forEach(((value) => value.addEventListener('click', this.close(value))));
    } catch (e) {
      Logging.error('The opening or closing trigger for the Modal is not defined:\n', this.element, '\n\n', e);
    }
  };

  public open: (id: (string | undefined), element?: HTMLElement) => (e?: Event) => void = (id: string | undefined, element?: HTMLElement) => (e?: Event) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.element.classList.add('displayed');
    if (this.onOpen){
      this.onOpen(id, element);
    }
    if (element) this.setPublisherDataInContactForm(element);
    this.eventBus.emit(new ModalOpenedEvent({ element: element }));
  };

  public close = (button?: HTMLElement) => () => {
    this.element.classList.remove('displayed');
    if (this.onClose) this.onClose();
    if (this.isProjectPage()) {
      this.contactFormModal!.classList.remove('submitted');
    }
    const comeBackId  = button?.dataset.backId;
    if (comeBackId === "detail-page-comeback-property") {
      window.scrollTo(0,0);
    }
    if (comeBackId) {
      // @ts-ignore
      gtag('event', comeBackId);
    }
  };

  private buildModalOpenTrigger = (openTrigger: HTMLElement[] | HTMLElement | undefined) => {
    if (openTrigger === undefined) return undefined;
    return Array.isArray(openTrigger) ? openTrigger : [openTrigger as HTMLElement];
  };

  public showModal = () => this.element.classList.add('displayed');

  private isProjectPage = () : boolean => this.pageData.pageViewType === PageViewType.PROJECT_PAGE_DIRECTORY;

  private setPublisherDataInContactForm = (element: HTMLElement) => {
    const projectPublisherName = element.dataset.projectpublisher;
    const projectPublisherImage = element.dataset.projectimage;
    if (!projectPublisherName || !projectPublisherImage) return;

    const contactModalPublisherNameElement = document.querySelector('div[data-contactpublishername="true"]') as HTMLElement;
    const contactModalPublisherImageElement = document.querySelector('img[data-contactpublisherimage="true"]') as HTMLImageElement;
    if (!contactModalPublisherNameElement || !contactModalPublisherImageElement) return;

    contactModalPublisherNameElement.innerText = projectPublisherName;
    contactModalPublisherImageElement.src = projectPublisherImage;
  };
}
